// extracted by mini-css-extract-plugin
export var formContainer = "_ma-0";
export var message = "_ma-1";